import type { JSX } from 'react';
import type { SurfaceOf } from './types';
import { CdsFindingView } from './CdsFindings';

export function CdsAlertsSurfaceView({ surface }: { surface: SurfaceOf<'cds-alerts'> }): JSX.Element {
  return (
    <section className="surface surface-cds" aria-label="Clinical decision support">
      <h3 className="surface-title">Clinical decision support</h3>
      {surface.findings.length === 0 ? <p className="muted">No findings.</p> : null}
      <ul className="cds-list">
        {surface.findings.map((f) => (
          <CdsFindingView key={f.findingId} finding={f} />
        ))}
      </ul>
      <p className="muted small">Engine: {surface.engine}</p>
    </section>
  );
}
